/**
 * Represents the key pressed during a KeyboardEvent.
 */
export var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["Enter"] = 0] = "Enter";
    KeyCode[KeyCode["Space"] = 1] = "Space";
    KeyCode[KeyCode["Plus"] = 2] = "Plus";
    KeyCode[KeyCode["Minus"] = 3] = "Minus";
    KeyCode[KeyCode["LeftArrow"] = 4] = "LeftArrow";
    KeyCode[KeyCode["UpArrow"] = 5] = "UpArrow";
    KeyCode[KeyCode["RightArrow"] = 6] = "RightArrow";
    KeyCode[KeyCode["DownArrow"] = 7] = "DownArrow";
    KeyCode[KeyCode["PageUp"] = 8] = "PageUp";
    KeyCode[KeyCode["PageDown"] = 9] = "PageDown";
    KeyCode[KeyCode["Escape"] = 10] = "Escape";
    KeyCode[KeyCode["Tab"] = 11] = "Tab";
    KeyCode[KeyCode["Alt"] = 12] = "Alt";
    KeyCode[KeyCode["Home"] = 13] = "Home";
    KeyCode[KeyCode["End"] = 14] = "End";
})(KeyCode || (KeyCode = {}));
/**
 * Gets a recognised KeyCode for a given keyboard event.
 * Returns undefined if the KeyCode is unknown (feel free to add it).
 */
export function getKeyCodeForEvent(event) {
    // Ignore deprecation since no valid cross-browser replacement
    const keyCode = event.which || event.keyCode;
    // Please sort these in numerical order
    switch (keyCode) {
        case 9:
            return KeyCode.Tab;
        case 13:
            return KeyCode.Enter;
        case 18:
            return KeyCode.Alt;
        case 27:
            return KeyCode.Escape;
        case 32:
            return KeyCode.Space;
        case 33:
            return KeyCode.PageUp;
        case 34:
            return KeyCode.PageDown;
        case 35:
            return KeyCode.End;
        case 36:
            return KeyCode.Home;
        case 37:
            return KeyCode.LeftArrow;
        case 38:
            return KeyCode.UpArrow;
        case 39:
            return KeyCode.RightArrow;
        case 40:
            return KeyCode.DownArrow;
        case 107:
        case 187:
            return KeyCode.Plus;
        case 109:
        case 189:
            return KeyCode.Minus;
        default:
            return undefined;
    }
}
//# sourceMappingURL=key-code.js.map